import { useCallback, useEffect, useState } from 'react'
import type { recipe } from '../../../utils/recipeUtils'

import '../Calendar/CalendarPopupContent.scss'
import { getMessage } from '../../../utils/messageUtils'
import type { MealType } from '../../../utils/calendarUtils'

interface TemplatePopupContentProps {
  recipeId: number | null | undefined
  type: MealType
  existingRecipes: recipe[] | undefined
  setPopupOnOk: React.Dispatch<React.SetStateAction<() => void>>
  storeRecipe: (newRecipeId: number) => Promise<void>
  closePopup: () => void
}

function TemplatePopupContent({
  recipeId,
  type,
  existingRecipes,
  setPopupOnOk,
  storeRecipe,
  closePopup,
}: TemplatePopupContentProps) {
  const [selectedRecipeId, setSelectedRecipeId] = useState<number | null>(
    recipeId ?? null
  )

  const handleOk = useCallback(async () => {
    if (selectedRecipeId !== null) {
      await storeRecipe(selectedRecipeId)
    }
    closePopup()
  }, [selectedRecipeId, storeRecipe, closePopup])

  useEffect(() => {
    setPopupOnOk(() => handleOk)
  }, [handleOk, setPopupOnOk])

  const handleItemSelectChange = (value: string) => {
    const id = parseInt(value, 10)
    if (!isNaN(id) && existingRecipes) {
      const selectedRecipe = existingRecipes.find(r => r.id === id)
      setSelectedRecipeId(selectedRecipe?.id ? selectedRecipe.id : null)
    }
  }

  function generateRecipeOptions() {
    if (!existingRecipes) return null
    return existingRecipes
      .filter(recipe => recipe[type])
      .map(optionRecipe => (
        <option key={optionRecipe.id} value={optionRecipe.id}>
          {optionRecipe.name}
        </option>
      ))
  }

  return (
    <div className="pop-up-form-row">
      <select
        id="calendar-recipe-select"
        className="calendar-recipe-select"
        onChange={e => handleItemSelectChange(e.target.value)}
        value={
          selectedRecipeId !== null
            ? (existingRecipes?.find(r => r.id === selectedRecipeId)?.id ?? '')
            : ''
        }
      >
        <option value="">{getMessage('recipe_select')}</option>
        {generateRecipeOptions()}
      </select>
    </div>
  )
}

export default TemplatePopupContent
